import React from 'react';

import PageLayout from '@frolight/components/PageLayout';
import Panel from '@frolight/components/Panel';
import usePageTitle from '@frolight/hooks/usePageTitle';
import useLocalizedFormattedText from '@frolight/hooks/useLocalizedFormattedText';

import UserPreferencesForm from './components/UserPreferencesForm';

const UserPreferences = () => {
  const { lftext } = useLocalizedFormattedText();

  const title = lftext('pages.user_preferences.title');
  
  usePageTitle(title);

  return (
    <PageLayout>
      <div className="content_layout">
        <Panel
          size="huge"
          title={ <h1>{ title }</h1> }
        >
          <UserPreferencesForm />
        </Panel>
      </div>
    </PageLayout>
  );

};

export default UserPreferences;
